function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TableList, TextButton, useOverlayContext } from 'seagull';
import { useStore } from "../../contexts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { EditMode, NotificationSettingsEntryType } from "../../models/NotificationSettingsModel";
import { selectors } from "../../store/state-selectors";
import { EditNotificationSettingsModal } from "./EditNotificationSettingsModal";
import { getNotificationsToShow, Table } from "./NotificationSettings.utils";
import styles from "./NotificationSettingsTable.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const typeMap = {
  [Table.Reminders]: NotificationSettingsEntryType.Recurring,
  [Table.Notifications]: NotificationSettingsEntryType.Single
};
export const NotificationSettingsTable = _ref => {
  let {
    data,
    tableType,
    columnDefs,
    selectedTab,
    headerItems,
    refresh,
    getRowItems
  } = _ref;
  const featureFlags = useFeatureFlags();
  const overlayContext = useOverlayContext();
  const showKarbonIntegration = useStore(selectors.integration.showKarbonIntegration);
  const showClientHubIntegration = useStore(selectors.integration.showClientHubIntegration);
  const showFinancialCentsIntegration = useStore(selectors.integration.showFinancialCentsIntegration);
  const showKeeperIntegration = useStore(selectors.integration.showKeeperIntegration);
  const notificationsTextMap = getNotificationsToShow({
    tab: selectedTab,
    showKarbonIntegration,
    showClientHubIntegration,
    showFinancialCentsIntegration,
    showKeeperIntegration,
    featureFlags
  });
  const handleEditClick = props => {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(EditNotificationSettingsModal, _objectSpread({
          selectedTab: selectedTab,
          dismissModal: dismissModal
        }, props));
      }
    });
  };
  return /*#__PURE__*/_jsxs(TableList.Provider, {
    columnDefs: columnDefs,
    hasActionColumn: true,
    children: [/*#__PURE__*/_jsx(TableList.Header, {
      items: headerItems,
      "data-testid": "".concat(tableType, "-table-header"),
      className: styles.header
    }), Object.entries(notificationsTextMap).map(_ref3 => {
      let [key, text] = _ref3;
      const notification = data[selectedTab][key];
      return notification && notification.type === typeMap[tableType] && /*#__PURE__*/_jsx(TableList.Row, {
        size: "fluid",
        items: getRowItems({
          notification,
          text,
          key
        }),
        "data-testid": "".concat(Table.Notifications, "-row-").concat(key),
        className: styles.row,
        actionColumn: notification.editMode === EditMode.Enabled && /*#__PURE__*/_jsx(TextButton, {
          onClick: () => handleEditClick({
            tableType,
            notification,
            notificationText: text,
            notificationName: key,
            refresh
          }),
          underline: "none",
          "data-testid": "".concat(tableType, "-row-").concat(key, "-edit"),
          children: "Edit"
        })
      }, key);
    })]
  });
};